import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { errorActions } from '../app/error-slice';
import * as errorSelectors from '../app/error-selectors';
import { ErrorView } from '../common/error-view';
import { ROOT_PATH } from '../routes/constants';
import { useSelector } from 'react-redux';

export function ErrorHandler({ criticalError, clearError, children }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const hasErrored = useSelector(errorSelectors.hasErrored);

  const closeModal = useCallback(() => {
    dispatch(errorActions.setHasErrored(false))
  }, [dispatch]);

  const goToMainMenu = useCallback(() => {
    if (hasErrored) closeModal();
    if (criticalError) clearError();
    history.push(ROOT_PATH);
  }, [clearError, closeModal, criticalError, hasErrored, history]);

  return (
    <>
      <ErrorView
        visible={criticalError || hasErrored}
        goToMainMenu={goToMainMenu}
        hideModal={!criticalError && closeModal}
      />
      {!criticalError && children}
    </>
  );
}
